import { runtimeStreamingModeSchema, runtimeTransportModeSchema } from "./controller-contract.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/provider-runtime-capability.ts
const providerRuntimeStreamingCapabilitySchema = z$1.enum(["preview_capable", "final_only"]);
const providerRuntimeImageInputCapabilitySchema = z$1.enum(["local_file_path", "unsupported"]);
const providerRuntimeWorkingDirectoryModeSchema = z$1.enum([
	"spawn_cwd",
	"cli_flag",
	"provider_workspace",
	"unsupported"
]);
const providerRuntimePreparationRequirementSchema = z$1.enum(["none", "required"]);
const providerRuntimeContinuationCapabilitySchema = z$1.enum(["standard", "provider_specific"]);
const providerRuntimeWorkspaceResumeBehaviorSchema = z$1.enum([
	"transparent",
	"provider_specific_switch",
	"validate_only"
]);
const providerRuntimeCapabilityDeclarationSchema = z$1.strictObject({
	executionContextVersion: z$1.union([z$1.literal(1), z$1.literal(2)]).optional(),
	streamingCapability: providerRuntimeStreamingCapabilitySchema,
	imageInputCapability: providerRuntimeImageInputCapabilitySchema.optional(),
	runtimeWorkingDirectoryMode: providerRuntimeWorkingDirectoryModeSchema,
	preparationRequirement: providerRuntimePreparationRequirementSchema,
	continuationCapability: providerRuntimeContinuationCapabilitySchema,
	workspaceResumeBehavior: providerRuntimeWorkspaceResumeBehaviorSchema
});
const daemonRuntimeAdapterCapabilitySnapshotSchema = z$1.strictObject({
	adapterId: z$1.string().min(1),
	transportModes: z$1.array(runtimeTransportModeSchema).min(1),
	defaultStreamingMode: runtimeStreamingModeSchema.optional(),
	capabilityDeclaration: providerRuntimeCapabilityDeclarationSchema
});
//#endregion
export { daemonRuntimeAdapterCapabilitySnapshotSchema, providerRuntimeCapabilityDeclarationSchema, providerRuntimeContinuationCapabilitySchema, providerRuntimeImageInputCapabilitySchema, providerRuntimePreparationRequirementSchema, providerRuntimeStreamingCapabilitySchema, providerRuntimeWorkingDirectoryModeSchema, providerRuntimeWorkspaceResumeBehaviorSchema };

//# sourceMappingURL=provider-runtime-capability.js.map